import { memo, useMemo } from 'react'
import { LeafletMap, Marker } from './LeafletMap'
import { Style } from 'inlines'

export type SingleMarkerMapProps = Marker & {
  zoom?: number
  height?: string
  style?: Style
}

const SingleMarkerMapInternal = ({
  lat,
  long,
  marker,
  zoom,
  height,
  style,
}: SingleMarkerMapProps) => {
  const markers = useMemo(
    () => [{ lat, long, marker }],
    [lat, long, marker],
  )

  return (
    <LeafletMap
      markers={markers}
      zoom={zoom}
      height={height}
      style={style}
    />
  )
}

export const SingleMarkerMap = memo(SingleMarkerMapInternal)
